
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "./i18n/config";

// Enable React concurrent features
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Enable hot module replacement (HMR)
if (import.meta.hot) {
  import.meta.hot.accept();
}
